import ToggleLabel from '@Components/Selectors/ToggleLabel'
import React, { useContext, useCallback } from 'react'
import { debounce } from 'lodash'
import { StoresContext } from '@App/contexts'

const CompactViewToggle = () => {
    const { userStore } = useContext(StoresContext)

    const onClick = useCallback(
        debounce((value) => {
            userStore.compactViewToggle(value)
        }, 500),
        []
    )

    return (
        <div className="compact-view-toggle">
            <ToggleLabel
                mainColor
                onClick={onClick}
                label="Compact View"
                checked={userStore.userInfo?.settings && userStore.userInfo.settings.showDetailedWorkCards}
            />
        </div>
    )
}

export default CompactViewToggle
